import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { formatPhoneNumber } from '../util';

import { BasicFlex } from '../Common';

import { Link } from 'react-router-dom';

import { Avatar, IconButton, Tooltip, lighten } from '@mui/material';

import MapsUgcRoundedIcon from '@mui/icons-material/MapsUgcRounded';

import useMessageDialog from '../../store/messages';

const ProfileBlock = styled(BasicFlex)`
  gap: 1rem;
  padding: 1rem 1.6rem;
  background-color: ${props => props.theme.colors.lightBg};
`;

const ProfileInfo = styled(BasicFlex)`
  gap: .3rem;

  .title {
    font-weight: 600;
    font-size: 1.6rem;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #08083e;
`

const ProfileBar = ({ name = "", phone, event = {} }) => {

  const showDialog = useMessageDialog((state) => state.showDialog);

  const handleShowDialog = () => {
    showDialog({
      customer_id: event.customer_id,
      customer_name: name,
      customer_phone: phone,
      resource: "appointments",
      resource_id: event.appointment_id,
    });
  }


  return (
    <ProfileBlock>
      <Avatar>{name.charAt(0).toUpperCase()}</Avatar>
      <ProfileInfo dir="column">
        <StyledLink className="title" to={`/customers/view/${event.customer_id}`}>{name}</StyledLink>
        <div>{formatPhoneNumber(phone)}</div>
      </ProfileInfo>

      <Tooltip title="Message Customer">
        <IconButton size="small" color="success" onClick={handleShowDialog}>
          <MapsUgcRoundedIcon size="small" />
        </IconButton>
      </Tooltip>
    </ProfileBlock>
  );
};

export default ProfileBar;